import axios from 'axios'

export default {

  async getMajors({commit}) {
    console.log('进入action.getMajors')
    await axios.get('/homepage/selectcollege/majorlist')
      .then((ret)=>{
        let {code,data} = ret
        if(code===0){
          let list = data.map((item) =>{
            return item['major_name']
          })
          commit('setMajors', list)
        }
      })
  },

  async getColleges({commit}) {
    console.log('进入action.getColleges')
    await axios.get('/homepage/querycollege/colleges')
      .then((ret)=>{
        let {code,data} = ret
        if(code===0){
          let list = data.map((item) =>{
            return item['college_name']
          })
          commit('setColleges', list)
        }
      })
  },

  async getYears({commit}) {
    console.log('进入action.getYears')
    await axios.get('/homepage/querycollege/years')
      .then((ret)=>{
        let {code,data} = ret
        if(code===0){
          let list = data.map((item) =>{
            return item['year']
          })
          commit('setYears', list)
        }
      })
  },

  async getSubjects({commit}) {
    console.log('进入action.getSubjects')
    await axios.get('/homepage/selectcollege/subjectlist')
      .then((ret)=>{
        let {code,data} = ret
        if(code===0){
          let list = data.map((item) =>{
            return {
              fullName: item['full_name'],
              shortName: item['short_name']
            }
          })
          commit('setSubjects', list)
        }
      })
  },

}